import { createUseStyles } from "react-jss"
import { getFontSize } from "../../theme/Mixins"


export default createUseStyles((theme: any) => ({
    modalContent: {
        fontFamily: ({ theme }) => `"${theme.TextFont}", sans-serif`,
        fontSize: ({ theme }) => getFontSize(theme.TextFontSize),
    },
    modalHeader: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "20px",
        borderBottom: "1px solid #D0D3DD",
        padding: "0 12px",
    },
    modalTitle: {
        display: "flex",
        height: "45px",
        alignItems: "center",
        alignSelf: "stretch",
        fontSize: "20px",
    },
    modalBody: {
        marginBottom: "20px",
        padding: "0 24px",
        height: "380px",
        overflowY: "auto",
    },
    modalFooter: {
        display: "flex",
        justifyContent: "flex-end",
        padding: "0 12px",
        alignItems: "center",
        borderTop: "1px solid #D0D3DD",
    },
    closeButton: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "20px",
        border: 0,
        background: 0,
        height: "45px",
        cursor: "pointer",
    },
}))